import { EFFY_ORDER_PLANS } from '../pricing/effyOrderPlans';
import { SITE_URL } from './seoPages';
import { FUEL_URL } from '../products/effyFuelContent';

// JSON-LD blocks for the home page and the two product pages.
// Only facts that are visible on the pages are used here: no ratings, no reviews.
// Prices come from effyOrderPlans.js so the markup always matches the pricing page.

export function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'EffyVenture',
    url: `${SITE_URL}/`,
    inLanguage: 'en-IN',
  };
}

function buildEffyOrderOffers() {
  const offers = [];
  for (const plan of EFFY_ORDER_PLANS) {
    offers.push({
      '@type': 'Offer',
      name: `${plan.name} plan`,
      price: String(plan.amount),
      priceCurrency: 'INR',
      url: `${SITE_URL}/effy-order-pricing`,
    });
  }
  return offers;
}

export function buildEffyOrderSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Effy Order',
    url: `${SITE_URL}/products/effy-order`,
    applicationCategory: 'BusinessApplication',
    applicationSubCategory: 'Order Management Software',
    operatingSystem: 'Web',
    inLanguage: ['en-IN', 'ta-IN'],
    description: 'GST billing, order management and inventory software for Indian small businesses. Create GST invoices, track orders, keep stock up to date and print delivery challans.',
    featureList: [
      'GST invoices with CGST, SGST and IGST',
      'Order management and tracking',
      'Inventory management with low stock alerts',
      'Delivery challan printing',
      'Barcode generation and printing',
      'Bulk order and item upload from Excel',
      'Customer management and order history',
      'GST and sales reports',
      'WhatsApp and email notifications',
      'Purchase order management',
    ],
    offers: buildEffyOrderOffers(),
    publisher: { '@type': 'Organization', name: 'EffyVenture', url: SITE_URL },
  };
}

// No price is shown for Effy Fuel on this site, so no offer is declared.
export function buildEffyFuelSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Effy Fuel',
    url: `${SITE_URL}/products/effy-fuel`,
    installUrl: FUEL_URL,
    applicationCategory: 'BusinessApplication',
    applicationSubCategory: 'Petrol Bunk Management Software',
    operatingSystem: 'Web',
    inLanguage: 'en-IN',
    description: 'Petrol bunk software to close every shift from meter readings, track credit customers and see petrol, diesel and oil stock.',
    featureList: [
      'Shift sales from meter readings',
      'Credit customer tracking and statements',
      'Petrol, diesel and oil stock',
      'Daily expenses',
      'Excel reports',
    ],
    publisher: { '@type': 'Organization', name: 'EffyVenture', url: SITE_URL },
  };
}

// SoftwareApplication block for one feature page, so Google ties the page to the product.
// Offers are only added for Effy Order, whose plan prices are shown on the pricing page.
export function buildSoftwareApplicationSchema(page) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: page.product.name,
    url: `${SITE_URL}${page.product.path}`,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    inLanguage: 'en-IN',
    description: page.metaDescription,
    publisher: { '@type': 'Organization', name: 'EffyVenture', url: SITE_URL },
  };
  if (page.product.name === 'Effy Order') {
    schema.offers = buildEffyOrderOffers();
    schema.inLanguage = ['en-IN', 'ta-IN'];
  }
  return schema;
}
